import {createWebHistory, createRouter} from "vue-router";

import routesDE from "@/router/routes/routesDE";
import routesDE_EN from "@/router/routes/routesDE-EN";
import routesNL from "@/router/routes/routesNL";
import routesNL_EN from "@/router/routes/routesNL-EN";


const router = createRouter({
	history: createWebHistory(),
	routes: switchRoutes() == [] ? routesDE : switchRoutes()
});

function switchRoutes() {
	let country 	= window.diamondStockConfig.country;
	let language	= window.diamondStockConfig.language;
	let routes		= [];

	if (country == 'nl') {
		if (language == 'en') {
			routes = routesNL_EN;
		} else {
			routes = routesNL;
		}
	} else {
		if (language == 'en') {
			routes = routesDE_EN;
		} else {
			routes = routesDE;
		}
	}

	return routes;
}

export default router;

